// @ts-ignore
import { getLogger } from '@jitsi/logger';
const logger = getLogger(__filename);
import { getWildixPlatform } from '../../../functions.any';
import { getUserDataFromPresence, sendFetchData } from './functions';
let isUserCanSendLogs = true;
export function sendStatsToKibanaNoDispatch(conference, connectionStatsProp, message) {
    try {
        if (!connectionStatsProp.length || !isUserCanSendLogs || !conference) {
            return;
        }
        const { displayName, websocketUser, email, ctijid, userId, room } = getUserDataFromPresence(conference);
        const connectionStatsExtendedData = connectionStatsProp.map((object) => {
            return {
                ...object,
                platform: navigator?.platform ?? navigator?.product ?? 'Platform not detected',
                userAgent: navigator?.userAgent ? navigator.userAgent : 'UserAgent not detected',
                displayName,
                userId,
                websocketUser,
                email,
                isPbxUser: Boolean(ctijid),
                wildixPlatform: getWildixPlatform(conference)
            };
        });
        const obj = {
            room,
            message,
            data: {
                connectionStats: connectionStatsExtendedData
            }
        };
        sendFetchData(obj).catch(() => {
            isUserCanSendLogs = false;
        });
    }
    catch (e) {
        logger.error('Error data with native send:', e);
    }
}
